import { Worker } from "@react-pdf-viewer/core";
import { App as AntApp, ConfigProvider } from "antd";
import { Suspense, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import PrivateRoute from "./components/PrivateRoute";
import CustomEmpty from "./components/ui/CustomEmpty";
import Loader from "./components/ui/Loader";
import { antdThemeConfig } from "./constants/config";
import { pdfWorkerURL } from "./constants/constants";

import useProfile from "./hooks/useProfile";
import { publicRouters, sidebarRouters } from "./routers/routers";

export default function App() {
  const { loading } = useProfile();
  // console.log("loading...");
  // const dispatch = useAppDispatch();
  // const { keycloak } = useKeycloak();
  // const [loading, setLoading] = useState(true);

  // console.log(removeHash("U2FsdGVkX1+gh5N2Y5jl0n82/tOkmczCSN6qKWcopOs="));

  // const isSuperAdmin = keycloak?.realmAccess?.roles?.includes("super_admin");
  // const isAdmin =
  //   keycloak?.realmAccess?.roles?.includes("admin") ||
  //   keycloak?.realmAccess?.roles?.includes("admin2");

  // useEffect(() => {
  //   if (keycloak?.authenticated && keycloak?.token) {
  //     if (keycloak?.token) {
  //       dispatch(userLoggedIn(keycloak?.token));

  //       // fetch(`${APP_API}${API_URL.getMe}/${keycloak?.tokenParsed?.email}`, {
  //       fetch(`${APP_API}${API_URL.getMe}`, {
  //         method: "GET",
  //         // mode: "no-cors",
  //         headers: {
  //           Authorization: `Bearer ${keycloak?.token}`,
  //           "ngrok-skip-browser-warning": "true",
  //         },
  //       })
  //         .then((res) => res.json())
  //         .then((data) => {
  //           console.log("data", data);
  //           dispatch(
  //             setUserInfo({
  //               ...data,
  //               data: {
  //                 ...data?.data,
  //                 permission: isSuperAdmin
  //                   ? "SUPER_ADMIN"
  //                   : isAdmin
  //                   ? "Admin"
  //                   : data?.data?.permission,
  //               },
  //             })
  //           );
  //           setLoading(false);
  //         })
  //         .catch((err) => {
  //           setLoading(false);
  //         });
  //     }
  //   } else {
  //     setTimeout(() => {
  //       setLoading(false);
  //       // removeSession();
  //     }, 5000);
  //   }
  // }, [
  //   dispatch,
  //   keycloak?.authenticated,
  //   keycloak?.token,
  //   keycloak?.tokenParsed?.email,
  //   isSuperAdmin,
  //   isAdmin,
  // ]);

  // const roleRoutes = sidebarRouters.map((item) => {
  //   if (item?.path === "/admin/businesses/business-list") {
  //     return {
  //       ...item,
  //       roles: (isSuperAdmin ? ["SUPER_ADMIN"] : item?.roles) as Role[],
  //     };
  //   }

  //   return item;
  // });

  useEffect(() => {
    let deviceId = localStorage.getItem("device_id");

    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem("device_id", deviceId);
    }
  }, []);

  return (
    <Worker workerUrl={pdfWorkerURL}>
      <ToastContainer />
      <ConfigProvider
        theme={antdThemeConfig}
        renderEmpty={() => <CustomEmpty rootClassName="py-20" />}
      >
        <AntApp>
          {loading ? (
            <Loader />
          ) : (
            <Routes>
              {/* <Route path="/" element={<Navigate to="/admin/dashboard" />} /> */}
              <Route
                path="/admin"
                element={<Navigate to="/admin/dashboard" />}
              />
              <Route
                path="/dashboard"
                element={<Navigate to="/admin/dashboard" />}
              />

              {/* Public routers */}
              {publicRouters.map(({ path, element: Element }, idx) => (
                <Route
                  path={path}
                  key={idx + path}
                  element={
                    <Suspense fallback={<Loader />}>
                      <Element />
                    </Suspense>
                  }
                />
              ))}

              {/* sidebar routers */}
              {sidebarRouters.map(({ path, element: Element, roles }, idx) => (
                <Route
                  path={path}
                  key={path + idx}
                  element={
                    <PrivateRoute roles={roles}>
                      <Suspense fallback={<Loader />}>
                        <Element />
                      </Suspense>
                    </PrivateRoute>
                  }
                />
              ))}
            </Routes>
          )}
        </AntApp>
      </ConfigProvider>
    </Worker>
  );
}
